import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import PublicationSection from '@app/publication-section';
import publicationItemFullDataFixtures from './fixtures/publication-item-full-data';
import publicationSectionItemsFixtures from './fixtures/publication-section-items';
import publicationSectionsFixtures from './fixtures/publication-sections';
import settings from '@app/app.settings';
declare const _user: any;

@Injectable()
export class ManageContentService {
  constructor(private http: HttpClient) { }

  getPublicationSections(params) {
    if (environment.isLocal) {
      return of(publicationSectionsFixtures);
    }

    return this.http.get(
      `${environment.APIUrl}${settings.publicationSectionsAPI({id: params.id})}`,
      {params: {apiKey: _user.centralUser.apiKey || environment.APIKey}},
    );
  }

  getPublicationItemFullData(id) {
    if (environment.isLocal) {
      return of(publicationItemFullDataFixtures);
    }

    return this.http.get(
      `${environment.APIUrl}${settings.publicationItemFullDataAPI({id})}`,
      {params: {apiKey: _user.centralUser.apiKey || environment.APIKey}},
    );
  }

  getPublicationSectionItems(params) {
    if (environment.isLocal) {
      return of(publicationSectionItemsFixtures);
    }

    return this.http.get(
      `${environment.APIUrl}${settings.publicationSectionItemsAPI(params)}`,
      {params: {apiKey: _user.centralUser.apiKey || environment.APIKey}},
    );
  }

  // WARN Apply proper end point URL
  toggleSectionItemFeatured(params: {id: string, state: boolean}) {
    if (environment.isLocal) {
      return of({message: params.state ? 'Items featured' : 'Items unfeatured'});
    }

    if (params.state) {
      return this.http.post(
        `${environment.APIUrl}${settings.publicationSectionItemAPI(params.id)}?apiKey=${environment.APIKey}`,
        {id: params.id},
      );
    } else {
      return this.http.delete(
        `${environment.APIUrl}${settings.publicationSectionItemAPI(params.id)}?apiKey=${environment.APIKey}`,
      );
    }
  }

  toggleSectionItemVisibility(params: {id: string, state: boolean}) {
    if (environment.isLocal) {
      return of({message: params.state ? 'Items binded from section' : 'Items unbinded from section'});
    }

    if (params.state) {
      return this.http.post(
        `${environment.APIUrl}${settings.publicationSectionItemAPI(params.id)}?apiKey=${environment.APIKey}`,
        {id: params.id},
      );
    } else {
      return this.http.delete(
        `${environment.APIUrl}${settings.publicationSectionItemAPI(params.id)}?apiKey=${environment.APIKey}`,
      );
    }
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/manage-content/manage-content.service.ts